import * as types from '../constants/ActionTypes'

const blockfuture = (state = [], action) => {
    switch (action.type) {
      case 'ADD_BLOCKFUTURE':
      return {
          type: "ADD_BLOCKFUTURE",
          timestatus: action.timestatus
        }
    case types.CLEAR_BLOCK:
        var newState = {...state};
        delete newState[action.id];
        return newState; 
      default:
        return state
    }
  }
  
  export default blockfuture